(function () {
  const path = window.location.pathname.replace(/\/+$/, '') || '/';

  // Redirect /cart → homepage with flag
  if (path === '/cart') {
    const url = new URL(window.location.origin + '/');
    url.searchParams.set('open_cart', '1');
    window.location.replace(url.toString());
    return;
  }

  const params = new URLSearchParams(window.location.search);
  if (params.get('open_cart') !== '1') return;

  const openDrawer = () => {
    const drawer = document.querySelector('cart-drawer-component');
    if (drawer && typeof drawer.open === 'function') {
      drawer.open();
      return true;
    }
    return false;
  };

  const clearFlag = () => {
    const url = new URL(window.location.href);
    url.searchParams.delete('open_cart');
    window.history.replaceState({}, '', url.pathname + url.search + url.hash);
  };

  // Try immediately
  if (openDrawer()) {
    clearFlag();
    return;
  }

  // Retry until available (important fix)
  const interval = setInterval(() => {
    if (openDrawer()) {
      clearFlag();
      clearInterval(interval);
    }
  }, 200);

  // Safety timeout (stop after 5s)
  setTimeout(() => clearInterval(interval), 5000);
})();